import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/RaisedButton'
import StatusDisplay from 'components/StatusDisplay'

class LogInScreen extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
    }
    this.updateValue = this.updateValue.bind(this)
    this.submit = this.submit.bind(this)
  }

  updateValue(field, e, value) {
    this.setState({ [field]: value })
  }
  submit() {
    const { username, password } = this.state
    const { onSubmit } = this.props
    onSubmit({ username, password })
  }

  render() {
    const { ui } = this.props
    const { username, password } = this.state
    const enableSubmit = !!username && !!password

    return (
      <div className="LogInScreen">

        <Paper className="container">
          <h1>VirtualClin</h1>
          <h2>Controle de Agendas</h2>

          <form>
            <TextField name="username" type="email"
              floatingLabelText="E-mail" fullWidth
              onChange={this.updateValue.bind(null, 'username')}
              />

            <TextField name="password"
              type="password" fullWidth
              floatingLabelText="Senha"
              onChange={this.updateValue.bind(null, 'password')}
              />

            <Button label="Entrar"
              primary fullWidth
              disabled={!enableSubmit}
              onClick={this.submit}
              />
          </form>

          <StatusDisplay status={ui.login}>
            Usuário não encontrado. Verifique se o e-mail e senha estão corretos.
          </StatusDisplay>

        </Paper>


      </div>
    )
  }
}
LogInScreen.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default LogInScreen



// WEBPACK FOOTER //
// ./src/components/_Screens/LogIn/index.js